import React from 'react';
import styled from 'styled-components';

import { Twitter, Facebook, Linkedin } from '@styled-icons/boxicons-logos';
import { rhythm } from "../utils/typography"
import { ToSecondaryAnchor } from './styleComponents/HoverStyles'
import { Boop } from './animatedComponents/Boop.js';
import EmojiWrapper from "./EmojiWrapper";

const ShareSocial = styled.div`
  margin: ${rhythm(0.25)} 0; 
  display: flex; 
  justify-content:flex-start;
  a{
    margin-right:${rhythm(0.5)};
  }
`;


const SharePost = ({ title, path, description }) => {
  return (
    <div>
      <span style={{
        margin: 0,
        fontSize: '0.8rem',
        color: 'var(--color-primary)',
      }}><EmojiWrapper emoji="📮" name="Share" /> Share this post</span>
      <ShareSocial>
        <ToSecondaryAnchor
          href={`https://twitter.com/intent/tweet/?text=Hey you'll👋, I just found this article by @JayMGurav,  that I thought was really interesting take on this subject, you'll can read it at&url=${path}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Boop y={-6}>
            <Twitter size="24" title="Twitter" />
          </Boop>
        </ToSecondaryAnchor>
        <ToSecondaryAnchor
          href={`https://www.facebook.com/sharer/sharer.php?u=${path}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Boop y={-6}>
            <Facebook size="24" title="Facebook" />
          </Boop>
        </ToSecondaryAnchor>
        <ToSecondaryAnchor
          href={`https://www.linkedin.com/shareArticle?mini=true&url=${path}&title=${title}&source=${description}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Boop y={-6}>
            <Linkedin size="24" title="Linkedin" />
          </Boop>
        </ToSecondaryAnchor>
      </ShareSocial >
    </div >
  )
}


export default SharePost;